import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { IVideoCategoriesContext, VideoCategoriesContext } from '../../videoCategoriesState/videoCategoriesContext';
import Item from './components/Item';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import classNames from 'classnames';
import style from './VideoCategories.module.scss';

const VideoCategories: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, videoCategories, currentPage, countOfItems } =
		useContext<IVideoCategoriesContext>(VideoCategoriesContext);
	const categoriesHeadingClasses = classNames(style.categories, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<>
			{videoCategories.videoCategoriesCount ? (
				<div className={style.container} data-test="VideoCategories">
					<div className={style.tableHeaders}>
						<Text
							className={categoriesHeadingClasses}
							translationNameSpace="listing"
							translationKey="nameLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
						<Text
							className={actionHeadingClasses}
							translationNameSpace="listing"
							translationKey="actionLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
					</div>
					{videoCategories.videoCategories.map((item, index) => (
						<Item data={item} key={item.id} index={index} />
					))}
					<PaginationComponent
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={videoCategories.videoCategoriesCount}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			) : (
				<NoResultsFound isVisible={!isLoading} />
			)}
		</>
	);
};

export default VideoCategories;
